import type { Booking } from '@/types/Booking';

/**
 * The label shown for a booking's owner on calendar tiles — LAST NAME only (surnames are how the
 * practice identifies bookings at a glance; full names are noisy on a dense calendar). Falls back to
 * first name, then email, then the raw member id so a tile is never blank when a record is partial.
 * Shared by the day view (Brick/Bubble) and week view (Column/ColumnMeetingBubble) so the two cannot
 * drift.
 */
export const formatBookingOwnerLabel = (booking: Booking): string => {
  const m = booking.member;
  if (m?.lastName) return m.lastName;
  if (m?.firstName) return m.firstName; // fallback when only a first name is populated
  if (m?.email) return m.email;
  return booking.memberId || 'Unknown member';
};
